import { render } from "./ExamBulkDownloadOffcanvas.vue?vue&type=template&id=4d7ea64b&scoped=true"
import script from "./ExamBulkDownloadOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamBulkDownloadOffcanvas.vue?vue&type=script&lang=js"

import "./ExamBulkDownloadOffcanvas.vue?vue&type=style&index=0&id=4d7ea64b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7ea64b"]])

export default __exports__